<template>
    <!-- 包内物品详情 -->
    <el-dialog
        title="标记物信息"
        :visible="value"
        width="750px"
        :close-on-click-modal="true"
        :append-to-body="false"
        :modal-append-to-body="false"
        @close="close"
    >
        <div class="fiscan-tip-detail">
            <div class="tip-info">
                <p>{{ $t('c.name') }}：{{ tipInfo.byName }}</p>
                <p>物品类别：{{ tipInfo.knowledgeName }}</p>
                <p>设备型号：{{ tipInfo.productName }}</p>
                <p>图像描述：{{ tipInfo.description ? tipInfo.description : '无' }}</p>
            </div>
            <el-carousel indicator-position="outside" :autoplay="false" height="400px" trigger="click"
                         :arrow="tipImageList.length>1? 'always':'never'">
                <el-carousel-item v-for="(item,index) in tipImageList" :key="index">
                    <div class="carousel-wrap">
                        <img :src="item.url" alt="">
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        id: {
            required: true
        }
    },

    data() {
        return {
            tipImageList: [],
            tipInfo: {},
        }
    },

    watch: {
        value(val) {
            // 打开
            if (val) {
                this.initDialog()
            }
        },
    },

    methods: {
        initDialog() {
            this.tipImageList = []
            this.$api.getByTipId(this.id).then(res => {
                const data = res.package
                this.tipImageList = [...data.image.dr, ...data.image.physicalMaps]
                this.tipInfo = data
            })
        },

        close() {
            this.$emit('input', false)
        }
    },
}
</script>

<style lang="scss">
.fiscan-tip-detail {
    .el-carousel__item {
        display: flex;
        justify-content: center;
        align-items: center;

        > img {
            max-width: 100%;
            max-height: 100%;
        }
    }

    .tip-info {
        position: absolute;
        min-width: 150px;
        max-width: 270px;
        min-height: 50px;
        padding: 5px 8px;
        border-radius: 5px;
        /* border-bottom-right-radius: 5px; */
        background-color: rgba(0, 0, 0, .5);
        transform: translateX(-25px);
        transition: all .3s;
        margin-left: 50px;
        color: #fff;
        text-align: left;
    }
}
</style>
